
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { registerLicense } from '@syncfusion/ej2-base';

// Registering Syncfusion license key
registerLicense('ORg4AjUWIQA/Gnt2VVhhQlFac1pJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkNjWn9fcnJQRWReVEA=');

const keysWhiteList = ['mapbox', environment.storagePrefix];
const keysToCopy = ['currentUser', 'geotikRefreshToken', 'timeZone'];

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => {
    if ('serviceWorker' in navigator && environment.production) {
      navigator.serviceWorker.register('./ngsw-worker.js');
    }
    for ( let i = 0, len = localStorage.length; i < len; ++i ) {
      if (keysToCopy.includes(localStorage.key( i ))) {
        localStorage.setItem(`${environment.storagePrefix}.${localStorage.key( i )}`, localStorage.getItem(localStorage.key( i )));
        localStorage.removeItem(localStorage.key( i ));
      } else if (keysWhiteList.every(key => localStorage.key( i )?.indexOf(key) === -1)) {
        localStorage.removeItem(localStorage.key( i ));
      }
    }
  })
  .catch(err => console.error(err));
